export enum RouteList {
  Home = '/',
  Login = '/login',
  Logout = '/logout',
  ResetPassword = '/reset-password',
  MyCampaigns = '/campaigns',
  Campaign = '/campaigns/:campaignId',
  CampaignCreate = '/campaigns/create',
  CampaignOverview = '/campaigns/:campaignId/overview',
  Ga4Config = '/campaigns/:campaignId/configure-ga4',
  // warning: this url made before form was done, so URL name and route structure might be different in future
  CampaignCreationSuccess = '/campaign-creation/success/:campaignId',
  Feedback = '#',
  Contact = '/contact',
  Profile = '/profile',
  EditUserGa4 = '/profile/ga4',
  EditBillingAddress = '/profile/edit-billing-address',
  EditContactAddress = '/profile/edit-contact-address',
  TermsAndConditions = '/terms-of-service',
  PrivacyPolicy = '/privacy-policy',
  Invoices = '/invoices',
}

export enum AdminRouteList {
  Overview = '/admin',
  Campaigns = '/admin/campaigns',
  Users = '/admin/users',
  Invoices = '/admin/invoices',
}
